import { render, staticRenderFns } from "./ActivarTicketConfigs.vue?vue&type=template&id=53eb3643"
import script from "./ActivarTicketConfigs.vue?vue&type=script&lang=js"
export * from "./ActivarTicketConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports